import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle, Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { StaticImage } from '../../../image'
import { urlResolverGetRedPointsRoot } from '../../../url-handling'

import redpoints from './redpoints.svg'
import { RedPointsBenefitList } from './RedPointsBenefitList'

export const RedPointsBenefitDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const globalConfig = useGlobalConfigContext()

  return (
    <Dialog
      data-qa-id="redpoints-benefit-dialog"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="redpoints.modal.title" />
      </DialogTitle>
      <DialogContent className="flex-col">
        <div className="mb-3 flex flex-row items-center">
          <StaticImage alt="" height={44} src={redpoints} width={44} />
          <h2 className="ml-2 w-fit text-m font-medium">
            <FormattedMessage id="redpoints.modal.description" />
          </h2>
        </div>

        <RedPointsBenefitList />

        <div className="rounded-s bg-light-primary-low p-5">
          <p className="mb-3 text-m font-medium">
            <FormattedMessage id="redpoints.modal.collecting.title" />
          </p>
          <p className="mb-3 text-dark-primary-strong">
            <FormattedMessage id="redpoints.modal.collecting.description" />
          </p>
          <div>
            <Link
              className="flex items-center font-medium"
              href={urlResolverGetRedPointsRoot(globalConfig)}
            >
              <FormattedMessage id="redpoints.modal.link.signUp" />
              <IconArrowRight className="ml-1 size-6" />
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
